import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthenticationService } from './authentication.service';
import { Clients } from '@models/security/clients';

interface TokenPayload {
  sub?: string;
  permissions?: string[];
}

@Injectable()
export class AuthorizationService {
  currentUserMail = '';

  constructor(private authenticationService: AuthenticationService) {}

  getPermissions(client: Clients = Clients.ZION): Observable<string[]> {
    const token = this.authenticationService.getAccessToken();
    if (!token) {
      this.currentUserMail = '';
      return of([]);
    }
    const payload = this.decodeTokenPayload(token);
    this.currentUserMail = payload?.sub ?? '';
    const allPermissions = payload?.permissions ?? [];
    const appPrefix = client + '.';
    const permissions = allPermissions.filter((p) => p.startsWith(appPrefix)).map((p) => p.substring(appPrefix.length));
    return of(permissions);
  }

  hasZionPermission(permission: string): Observable<boolean> {
    return this.getPermissions(Clients.ZION).pipe(map((p) => p.includes(permission)));
  }

  hasMarkusPermission(permission: string): Observable<boolean> {
    return this.getPermissions(Clients.MARKUS).pipe(map((p) => p.includes(permission)));
  }

  hasZionPermissions(permissions: string[]): Observable<boolean> {
    return this.getPermissions(Clients.ZION).pipe(map((p) => p.some((perm) => permissions.includes(perm))));
  }

  hasPonchPermission(permission: string): Observable<boolean> {
    return this.getPermissions(Clients.PONCH).pipe(map((p) => p.includes(permission)));
  }

  private decodeTokenPayload(token: string): TokenPayload | null {
    try {
      const parts = token.split('.');
      if (parts.length !== 3) {
        return null;
      }
      const base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
      return JSON.parse(atob(base64)) as TokenPayload;
    } catch {
      return null;
    }
  }
}
